import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Button from "app/storybookComponents/Button";
import { useAppSelector, useAppDispatch } from "utils/redux/hooks";
import {
  deleteUserByUserAccountId,
  selectUserDeletedStatus,
  resetUserDeletedState,
  selectCurrentUserAccountId,
} from "app/containers/Global/slice";

interface Props {
  show: boolean;
  onHide: () => void;
}
export default function DeactivateSelfModal({ show, onHide }: Props) {
  const dispatch = useAppDispatch();
  const deleteUserStatus = useAppSelector(selectUserDeletedStatus);
  const loggedInUserAccountId = useAppSelector(selectCurrentUserAccountId);

  // Upon a successful request we close the modal and reset the state for the response status
  useEffect(() => {
    if (deleteUserStatus === "succeeded") {
      onHide();
      dispatch(resetUserDeletedState());
    }
  }, [deleteUserStatus, onHide, dispatch]);

  // ------------------ OnClick Helper Functions ------------------

  const onDeactivateUserClick = async () => {
    if (!loggedInUserAccountId) return;
    await dispatch(deleteUserByUserAccountId(loggedInUserAccountId));
  };

  return (
    <Modal show={show} onHide={onHide} className="simple-modal" size="lg">
      <div className="modal-title-row">
        <h2>Deactivate User</h2>
        <Button
          onClick={() => onHide()}
          variant={"secondary-blue"}
          style={{ border: "none", width: "auto" }}
          xIcon
        />
      </div>
      <div className="deactivate-user-modal-body">
        <span>Are you sure you want to deactivate your account?</span>
        <p>
          You will no longer have access to the platform and be removed from all
          teams and departments you are currently a part of.
        </p>
        <div className="deactivate-user-modal-footer">
          <Button onClick={() => onHide()} variant="secondary-blue">
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onDeactivateUserClick}
            disabled={deleteUserStatus === "loading"}
          >
            Confirm Deactivation
          </Button>
        </div>
      </div>
    </Modal>
  );
}
